import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

export const brandName = (theme: Theme) => css`
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${theme.text.body};
`;

export const noClip = css`
  white-space: normal;
`;
